import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry error monitoring and performance tracking
 * This should be imported early in the application entry point
 */
Sentry.init({
  dsn: import.meta.env['VITE_SENTRY_DSN'] || undefined,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      // Block elements with class .sentry-mask (e.g., credit card fields, passwords)
      block: ['.sentry-mask'],
    }),
  ],
  sendDefaultPii: true,
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of transactions for performance monitoring
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample 10% of sessions
  replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with errors
  // Environment
  environment: import.meta.env.MODE,
  // Enable debug mode in development
  debug: import.meta.env.MODE === 'development',
  // Additional options
  beforeSend(event) {
    // Filter out events in development if needed
    if (import.meta.env.MODE === 'development') {
      console.log('Sentry Event:', event);
    }

    // Ignore Segment CDN load failures
    let errorMessage: string = event?.exception?.values?.[0]?.value || '';
    if (errorMessage.includes('Load failed') && errorMessage.includes('cdn.segment.com')) {
      return null;
    }

    // Ignore invalid login credentials error on login page
    errorMessage = String(event.contexts?.['errorContext']?.['message']) || '';
    if (errorMessage.includes('Invalid login credentials')) {
      return null;
    }

    return event;
  },
});
